<template>
  <md-card class="mb-card member-categories-chart">
    <md-card-header class="md-card-header-warning mb-header-fullwidth">
      <h4>
        <md-icon class="icon">bar_chart</md-icon>
        Mitglieder nach Kategorien
      </h4>
    </md-card-header>
    <md-card-content :key="chartdata.labels.length">
      <DoughnutChart
        v-if="chartdata.labels.length"
        :chartdata="chartdata"
        :options="chartoptions"
      ></DoughnutChart>
      <div v-if="loading && !chartdata.labels.length" class="spinner">
        <md-progress-spinner md-mode="indeterminate"></md-progress-spinner>
      </div>
      <table v-if="showTable && chartdata.labels.length">
        <tr v-for="(label, i) in chartdata.labels" :key="i">
          <td>
            <div
              class="color"
              :style="{
                backgroundColor: chartdata.datasets[0].backgroundColor[i]
              }"
            ></div>
          </td>
          <td align="right">
            {{ chartdata.datasets[0].data[i] }}
          </td>
          <td>{{ label }}</td>
        </tr>
      </table>
    </md-card-content>
  </md-card>
</template>

<style scoped lang="scss">
.icon {
  font-size: 30px !important;
}
.mb-card .md-card-header-icon .category {
  color: #999999;
  font-size: 14px;
  padding-top: 10px;
  text-align: right;
}
.member-categories-chart {
  table {
    margin-top: 20px;
    margin-left: auto;
    margin-right: auto;

    td {
      vertical-align: top;
      padding: 0 5px;
      line-height: 1.5;
    }

    .color {
      border-radius: 100%;
      content: "";
      display: inline-block;
      width: 10px;
      height: 10px;
      background-color: currentColor;
    }
  }
}
</style>

<script>
import DoughnutChart from "@/components/Clouseau/DoughnutChart.vue";
export default {
  props: {
    load: {
      type: Boolean,
      default: true
    },
    showTable: {
      type: Boolean,
      default: false
    },
    showLegend: {
      type: Boolean,
      default: false
    }
  },
  components: {
    DoughnutChart
  },
  data() {
    return {
      loading: true,
      chartoptions: {
        legend: {
          display: this.showLegend
        },
        responsive: true,
        maintainAspectRatio: false,
        tooltips: {
          backgroundColor: "#fff",
          bodyFontColor: "#000",
          titleFontFamily: '"Roboto", "Helvetica", "Arial", sans-serif'
        }
      }
    };
  },
  created() {
    this.getData();
  },
  computed: {
    member_categories() {
      return this.$store.getters["member_categories/list"];
    },
    statistics() {
      return this.$store.getters["statistics/list"];
    },
    chartdata() {
      const chartdata = {
        labels: [],
        datasets: [
          {
            label: "Mitglieder",
            backgroundColor: [],
            data: []
          }
        ]
      };
      if (
        !this.member_categories ||
        !this.member_categories.length ||
        !this.statistics ||
        !this.statistics.length
      ) {
        return chartdata;
      }
      for (const member_category of this.member_categories) {
        const count = this.getStatsValue(
          "members_category_" + member_category.id
        );
        if (count) {
          chartdata.labels.push(member_category.description);
          chartdata.datasets[0].data.push(
            this.getStatsValue("members_category_" + member_category.id)
          );
          chartdata.datasets[0].backgroundColor.push(member_category.color);
        }
      }
      return chartdata;
    }
  },
  methods: {
    async getData() {
      await this.$store.dispatch("member_categories/list", {
        filter: {
          ...{ "with-trashed": 1 }
        },
        page: { size: 100 }
      });
      if (this.load) {
        await this.$store.dispatch("statistics/list");
      }
      this.loading = false;
    },
    getStatsValue(name) {
      if (this.statistics) {
        const statistic = this.statistics.find(s => s.name === name);
        if (!statistic) return 0;
        return statistic.value;
      }
    }
  }
};
</script>
